import { useRef, useState } from "react";
import { Modal, Box, IconButton, Button, Divider, Switch } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import uploadIcon from "assets/setting/uploadIcon.svg";
import DeleteIcon from "assets/setting/DeleteIcon.png";
import toggleImage from "assets/setting/toggleImage.png";
import { getIcon } from "utils/iconsConfig";
import { blue } from "@mui/material/colors";

const MediaUploadModal = ({
  open,
  onClose,
  files,
  setFiles,
  selectedIndex,
  setSelectedIndex,
  accept,
  title,
  previewLabel,
  uploadLabel,
  isImage,
  onSave,
  isEdit,
  setUploadedVideos,
  setVideoURLs,
  uploadedVideos,
}) => {
  const inputRef = useRef();
  const [showPreview, setShowPreview] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const handleToggleChange = () => {
    setShowPreview(!showPreview);
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    if (selectedFiles.length === 0) return;

    setFiles((prev) => {
      const updated = [...prev];
      if (editingIndex !== null) {
        // Replace only the selected index with the first file
        updated[editingIndex] = selectedFiles[0];
      } else {
        // Add all selected files
        updated.push(...selectedFiles);
      }
      return updated;
    });

    setEditingIndex(null); // reset editing mode
    e.target.value = ""; // allow re-uploading the same file
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFiles = Array.from(e.dataTransfer.files).filter((f) => (isImage ? f.type.startsWith("image/") : f.type.startsWith("video/")));

    // Create blob URLs only once
    const blobUrls = droppedFiles.map((file) => URL.createObjectURL(file));

    // Update states
    setUploadedVideos((prev) => [...prev, ...droppedFiles]);
    setVideoURLs((prev) => [...prev, ...blobUrls]);

    if (uploadedVideos.length === 0 && droppedFiles.length > 0) {
      setSelectedIndex(0);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleBoxClick = () => {
    inputRef.current.click();
  };

  const handleDelete = (idx) => {
    setFiles((prev) => prev.filter((_, i) => i !== idx));
    setSelectedIndex((prev) => (prev > 0 ? prev - 1 : 0));
  };

  const handleClose = () => {
    setShowPreview(false);
    onClose();
  };

  const handleSave = () => {
    setShowPreview(false);
    onSave();
  };

  return (
    <Modal open={open} onClose={handleClose} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Box
        sx={{
          bgcolor: "#101010",
          borderRadius: "12px",
          // p: "16px",
          width: "1200px",
          height: "600px",
          position: "relative",
          border: "none",
          boxShadow: 24,
          display: "flex",
          flexDirection: "column",
          outline: "none",
        }}
      >
        <input type="file" accept={accept} multiple={editingIndex === null} style={{ display: "none" }} ref={inputRef} onChange={handleFileChange} />
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "22rem", alignItems: "center", padding: "0px 16px", paddingTop: "8px" }}>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <div style={{ color: "#fff", fontSize: 20, paddingLeft: "16px" }}>{title}</div>
            {files.length > 0 && (
              <Button
                variant="outlined"
                sx={{
                  color: "#fff",
                  border: "1px solid #fff",
                  borderRadius: "5px",
                  fontSize: "18px",
                  fontFamily: "Karla",
                  fontWeight: 400,
                  textTransform: "none",
                  px: 3,

                  transform: "translateX(-50%)",

                  minWidth: 150,
                  height: "40px",
                  "&:hover": {
                    backgroundColor: "transparent",
                    border: "1px solid #fff", // Keep border consistent on hover
                  },
                  "&:focus": {
                    outline: "none",
                  },
                }}
                onClick={() => inputRef.current.click()}
              >
                {isImage ? "Add Image +" : "Add Video +"}
              </Button>
            )}
          </div>

          <IconButton sx={{ width: "32px", height: "32px", border: "1px solid #8B8B8B", borderRadius: "4px" }} aria-label="close" onClick={handleClose}>
            <CloseIcon sx={{ width: "16px", height: "16px", color: "#8B8B8B" }} />
          </IconButton>
        </div>

        {files.length === 0 ? (
          <Box
            sx={{
              border: "1px dashed #444",
              // width: "1136px",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#101010",
              flexDirection: "column",
              mt: 2,
              cursor: "pointer",
              // border: "2px solid red",
              margin: "1vw 2vw 2vw",
            }}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onClick={handleBoxClick}
          >
            <img src={uploadIcon} alt="Upload" width={"180px"} height={"180px"} style={{ marginBottom: 16 }} />
            <div style={{ color: "#8B8B8B", fontSize: 16, marginBottom: 8, fontWeight: 400, fontFamily: "Poppins" }}>{uploadLabel}</div>
          </Box>
        ) : (
          <Box sx={{ display: "flex", flex: 1, minHeight: 0, height: "100%", borderTop: "1px solid #444444", mt: 1.5 }}>
            {/* Left: List */}
            <Box
              sx={{
                overflowY: "auto",
                borderRight: "5px solid #191818",
                flex: 1,
                height: "100%",
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                // alignItems: "center",
              }}
            >
              <Box
                sx={{
                  overflowY: "auto",
                  overflowX: "hidden",
                  // pr: 2,
                  flex: 1,
                  height: "100%",
                  minHeight: 0,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  position: "relative",
                  scrollbarWidth: "thin",
                  scrollbarColor: "#999999 transparent",
                  "&::-webkit-scrollbar": {
                    width: "3px",
                    background: "transparent",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#999999",
                    borderRadius: "20px",
                    minHeight: "60px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "transparent",
                  },
                }}
              >
                {files.map((file, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 1,
                      p: 1,
                      cursor: "pointer",
                      width: "700px",
                      height: "80px",
                      justifyContent: "center",

                      borderBottom: "1px solid #444444",
                    }}
                    onClick={() => setSelectedIndex(idx)}
                  >
                    {isImage ? (
                      <>
                        <span style={{ marginRight: 12, display: "flex", alignItems: "center" }}>
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="#8B8B8B">
                            <circle cx="4" cy="4" r="1.5" />
                            <circle cx="4" cy="9" r="1.5" />
                            <circle cx="4" cy="14" r="1.5" />
                            <circle cx="10" cy="4" r="1.5" />
                            <circle cx="10" cy="9" r="1.5" />
                            <circle cx="10" cy="14" r="1.5" />
                          </svg>
                        </span>
                        <img
                          src={typeof file === "string" ? file : URL.createObjectURL(file)}
                          alt={file.name}
                          width={48}
                          height={48}
                          style={{ borderRadius: 8, objectFit: "cover", marginRight: 16 }}
                        />
                      </>
                    ) : (
                      <video src={typeof file === "string" ? file : URL.createObjectURL(file)} width={48} height={48} style={{ borderRadius: 8, objectFit: "cover", marginRight: 16 }} />
                    )}

                    <span style={{ color: "#fff", flex: 1, marginRight: 12 }}>{typeof file === "string" ? file.split("/").pop() : file.name}</span>
                    {isEdit && (
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          setEditingIndex(idx);
                          inputRef.current.click();
                        }}
                        size="small"
                      >
                        {getIcon("greenEditIcon")}
                      </IconButton>
                    )}

                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDelete(idx);
                      }}
                      size="small"
                    >
                      {getIcon("DustbinIcon")}
                    </IconButton>
                  </Box>
                ))}
              </Box>

              <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    bgcolor: "#50C878",
                    color: "#000",
                    fontWeight: 700,
                    width: 120,
                    bottom: 16,
                    "&:hover": {
                      backgroundColor: "#50C878",
                    },
                    "&:focus": {
                      outline: "none",
                    },
                  }}
                  onClick={handleSave}
                >
                  SAVE
                </Button>
              </div>
            </Box>

            {/* Right: Preview */}
            <Box sx={{ width: "430px", pl: 0, display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
              <div
                style={{
                  color: "#fff",
                  fontWeight: 400,
                  borderBottom: "5px solid #191818",
                  px: "16px",
                  py: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontSize: "16px",
                  marginBottom: "12px",
                }}
              >
                <h6 style={{ fontSize: "16px", margin: 0, padding: 0, paddingLeft: "16px" }}>Preview</h6>
                <Switch color="success" onChange={handleToggleChange} />
              </div>

              {showPreview ? (
                <Box
                  sx={{
                    overflowY: "auto",
                    background: "#101010",
                    flex: 1,
                    minHeight: 0,
                    scrollbarWidth: "thin",
                    scrollbarColor: "#999999 transparent",
                    "&::-webkit-scrollbar": {
                      width: "3px",
                      background: "transparent",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#999999",
                      borderRadius: "20px",
                      minHeight: "60px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "transparent",
                    },
                  }}
                >
                  <div style={{ color: "#aaa", fontSize: 14, marginBottom: 8, paddingLeft: "16px" }}>{previewLabel}</div>
                  {files.map((file, idx) =>
                    isImage ? (
                      <img
                        key={idx}
                        //   src={URL.createObjectURL(file)}
                        src={typeof file === "string" ? file : URL.createObjectURL(file)}
                        alt="preview"
                        style={{ width: "100%", borderRadius: 0, objectFit: "contain", marginBottom: 16 }}
                      />
                    ) : (
                      <video key={idx} src={typeof file === "string" ? file : URL.createObjectURL(file)} controls style={{ width: "100%", borderRadius: 0, objectFit: "contain", marginBottom: 16 }} />
                    )
                  )}
                </Box>
              ) : (
                <Box sx={{ flex: 1, minHeight: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <img src={toggleImage} width={"175px"} height={"215px"} />
                </Box>
              )}
            </Box>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default MediaUploadModal;
